const MotorInsurance = () => {
    return (
        <div>

            <div className="flex flex-col justify-center items-center">
            <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
            <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
                <div className="flex flex-col justify-center">
                <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                    Motor Insurance
                </h1>
                <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                    Third-party comprehensive motor insurance provides a comprehensive cover to a third person 
                    who has been injured in an accident involving the insurer and their vehicle, be it a car, 
                    scooter, motorbike, truck, or any other vehicle. TCS, in collaboration with the leading insurance 
                    companies, provides third-party liability policy to the insured. This covers the insured in the event 
                    of an accident in which insured’s vehicle causes bodily injury or death of a third party and/or the 
                    damage to the property of the third party.
                </p>
                
                    
                </div>
                <div className="flex-1 flex flex-col justify-center sm:mt-[0rem] mt-[1rem]">
                <img src="/financial-services/motorinsurance.jpg" alt="" className="max-w-[100%] rounded-md"/>
                </div>
            </div>
                
            </div>
        </div>
    )
};
export default MotorInsurance;